import cookie from '../../cookie';
import PudoApi from '../api/pudo-api';
import {getOrderNumber, getSettings, isGuest} from '../selectors/selectors';
import bigQueryMetricRecorder from '../tracking/bigQueryMetricRecorder';
import Track from '../utils/tracking';
import * as types from './action-types';
import {getDeliveryOptions} from './deliveryOptionActions';
import {loadPudoSavedAddresses} from './pudo-actions';

export function updateDeliveryType(deliveryType) {
  try {
    bigQueryMetricRecorder(
      'updateDeliveryType', [{name: 'deliveryType', value: deliveryType}], [], 'impression',
    );
  } catch (error) {
    Track.track(error);
  }
  
  return {type: types.UPDATE_DELIVERY_TYPE, deliveryType};
}

export function switchToResidential() {
  return (dispatch) => {
    dispatch(updateDeliveryType('residential'));
  };
}

export function switchToPudo() {
  return (dispatch) => {
    dispatch(updateDeliveryType('pudo'));
    dispatch(getDeliveryOptions());
  };
}

export function updatePudoStatus(country) {
  return (dispatch, getState) => {
    const shouldDeferDeliveryOptionCallUntilPudoAvailabilityCallComplete = getSettings(getState()).should_defer_delivery_option_call_until_pudo_availability_call_complete;
    
    PudoApi.getPudoStatus(country)
      .then((status) => {
        dispatch({type: types.UPDATE_PUDO_STATUS, status});
    
        if (status && getSettings(getState())?.default_to_collection) {
          dispatch(switchToPudo());
        } else if (shouldDeferDeliveryOptionCallUntilPudoAvailabilityCallComplete) {
          dispatch(getDeliveryOptions());
        }
      })
      .catch(() => {
        if (shouldDeferDeliveryOptionCallUntilPudoAvailabilityCallComplete) {
          dispatch(getDeliveryOptions());
        }
      });
  };
}

export function setGoogleMapsLoading(isLoading) {
  return {type: types.SET_GOOGLE_MAPS_LOADING, isLoading};
}

export function setGoogleMapsInitStatus(status) {
  return {type: types.INIT_PUDO_GOOGLE_MAPS_SUCCESS, status};
}

export function updateValidStatus(isValid) {
  return {type: types.UPDATE_VALID_STATUS, isValid};
}

export const initialiseDeliverySection = () => (dispatch, getState) => {
  const settings = getSettings(getState());
  const {userLocation} = getState().site;
  const shouldDeferDeliveryOptionCallUntilPudoAvailabilityCallComplete = !!settings?.should_defer_delivery_option_call_until_pudo_availability_call_complete;
  const clickAndCollectEnabled = settings.click_and_collect_enabled;
  
  if (userLocation && clickAndCollectEnabled) {
    dispatch(updatePudoStatus(userLocation));
  } else if (shouldDeferDeliveryOptionCallUntilPudoAvailabilityCallComplete) {
    dispatch(getDeliveryOptions());
  }
  
  const deliveryTypeFromSession = sessionStorage.getItem(`deliveryType-${getOrderNumber(getState())}`);
  
  if (deliveryTypeFromSession === 'pudo') {
    dispatch(switchToPudo());
  } else {
    dispatch(switchToResidential());
  }
  
  if (clickAndCollectEnabled && !isGuest(getState())) {
    dispatch(loadPudoSavedAddresses(true));
  }
};
